import { render } from "./transfers.vue?vue&type=template&id=54f8c379"
import script from "./transfers.vue?vue&type=script&lang=js"
export * from "./transfers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__